module.exports = __webpack_public_path__ + "static/img/解决方案-矿山全场景AI视频识别解决方案- 主运输系统防护.68465321.png";